<script>
import Footer from "@/components/navigation/Footer.vue";

export default {
  components: {Footer },
}
</script>

<template>
    <div id="fullscreen-with-footer-layout">
      <router-view></router-view>
      <Footer />
    </div>
</template>
